//WE.Flow.Html.Contracts.Manifests.TestSuiteManifest

export class TestSuiteManifest {
    name: string = "";
    tests: string[] = null;
}
